import { TransNoContext } from "@lingui/react/server";
import { useLingui } from "../../lib/i18n/useLingui";
import React from "react";

// Renders `TransNoContext` (what Lingui's `Trans` renders once it has read the `LinguiContext`) with
// sparkle's own context instead of the consumer's.
export function Trans(props) {
  const lingui = useLingui();
  return /*#__PURE__*/React.createElement(TransNoContext, {
    ...props,
    lingui: lingui
  });
}
//# sourceMappingURL=Trans.js.map